import { useCallback } from "react"

export const useGetHistoryItem = (itemsArray = [], addedItems = [], changedItems = [], removedItems = []) => {
  return useCallback((item) => {
    const originalIndex = itemsArray.findIndex(w => item?._id === w?._id);
    const changeState = (changedItems.find(([index]) => +index === +originalIndex));
    const action = addedItems.some((addedItem) => item._id === addedItem?._id)
    ? 'added'
    : changedItems.some(([index]) => +index === +originalIndex)
      ? 'changed'
      : (removedItems?.length && removedItems?.some((removedItem) => removedItem?._id === item?._id))
        ? 'removed'
        : undefined
    return { prevState: changeState?.[1], prevIndex: changeState?.[0], action };
  }, [itemsArray, addedItems, changedItems]);
}